// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"card-image-type-4-m__wrapper__1GpYw","headline":"card-image-type-4-m__headline__1INHO"};